import type { AuthProvider } from "@refinedev/core";

import { getAdminPublicConfig } from "../config/public-config";

const disabledMessage =
  "The Phase 1 development authentication placeholder is disabled. CHT-697 owns real Supabase authentication and trusted staff authorization.";

export const developmentAuthProvider: AuthProvider = {
  login: async () => {
    const config = getAdminPublicConfig();
    if (!config.developmentAuthPlaceholderEnabled) {
      return {
        success: false,
        error: { name: "DevelopmentAuthDisabled", message: disabledMessage },
      };
    }

    return { success: true, redirectTo: "/home" };
  },
  logout: async () => ({ success: true, redirectTo: "/login" }),
  check: async () => {
    const config = getAdminPublicConfig();
    return config.developmentAuthPlaceholderEnabled
      ? { authenticated: true }
      : { authenticated: false, logout: true, redirectTo: "/login" };
  },
  getPermissions: async () => {
    const config = getAdminPublicConfig();
    return config.developmentAuthPlaceholderEnabled ? [config.developmentStaffRole] : [];
  },
  getIdentity: async () => {
    const config = getAdminPublicConfig();
    if (!config.developmentAuthPlaceholderEnabled) return null;
    return {
      id: "development-placeholder",
      name: "Development staff placeholder",
      role: config.developmentStaffRole,
    };
  },
  onError: async () => ({}),
};
